import Header from "@/components/landing/Header";
import HeroSection from "@/components/landing/HeroSection";
import CustomerLogosSection from "@/components/landing/CustomerLogosSection";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  softwareSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";
import WhyChatheroSection from "@/components/landing/WhyChatheroSection";
import BenefitsSection from "@/components/landing/BenefitsSection";
import WhatIsChatheroSection from "@/components/landing/WhatIsChatheroSection";
import AgentsSection from "@/components/landing/AgentsSection";
import KnowledgeBaseSection from "@/components/landing/KnowledgeBaseSection";
import MittelstandSection from "@/components/landing/MittelstandSection";
import SecuritySection from "@/components/landing/SecuritySection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";

const Index = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen">
      <SEOHead page="home" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        softwareSchema,
        createWebPageSchema(
          "Chathero – AI Agent & AI Agents für den Mittelstand",
          "Chathero ist die führende AI Agent Plattform für mittelständische Unternehmen. Automatisieren Sie Kundenservice, Marketing und Sales mit intelligenten AI Agents.",
          "/",
          [{ name: "Home", url: "/" }]
        ),
      ]} />
      <LLMMetadataHead
        title="Chathero – AI Agent & AI Agents für den Mittelstand"
        description="Chathero ist die führende AI Agent Plattform für mittelständische Unternehmen. Automatisieren Sie Kundenservice, Marketing und Sales mit intelligenten AI Agents. DSGVO-konform & gehostet in Deutschland."
        keywords="AI Agent, AI Agent, Kundenservice Automatisierung, Mittelstand, DSGVO, Chatbot Deutschland, künstliche Intelligenz, WhatsApp Business"
        canonicalUrl="https://chathero.ai/"
        aiCategory="SaaS, AI Agent Platform, Customer Communication"
        aiEntityType="AI Agent Platform"
        aiUseCase="Kundenkommunikation automatisieren, Kundenservice, Marketing, Vertrieb"
        aiFeatures="AI Agents, Wissensdatenbank, Unified Inbox, WhatsApp Business, Workflows, CRM-Integration"
      />
      <Header />
      <main>
        {/* Above the fold - loaded eagerly */}
        <HeroSection />
        <CustomerLogosSection />

        <WhyChatheroSection />
        <BenefitsSection />
        <WhatIsChatheroSection />
        <AgentsSection />
        <KnowledgeBaseSection />
        <MittelstandSection />
        <SecuritySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
